"use client";

import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";
import { usePathname } from "next/navigation";

export function BannedSessionRedirect() {
  const { data: session, status } = useSession();
  const pathname = usePathname();
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (status !== "authenticated") {
      hasRedirectedRef.current = false;
      return;
    }

    const isBanned = Boolean(session?.user?.isBanned);
    const isSuspendedRoute =
      pathname === "/auth/account-suspended" || pathname === "/auth/account-suspended/enter";

    if (!isBanned || isSuspendedRoute || hasRedirectedRef.current) {
      return;
    }

    hasRedirectedRef.current = true;
    window.location.replace("/auth/account-suspended/enter");
  }, [pathname, session?.user?.isBanned, status]);

  return null;
}
